import {liquidObjectsUsed} from "utils/liquid";
import React from "react";
import FontAwesome from "utils/FA";
import {pluralize} from "utils/strings";
import ensureKeyed from "utils/ensureKeyed";
import {faExclamationTriangle} from "@fortawesome/pro-solid-svg-icons/faExclamationTriangle";

/**
 * Searches for contact tokens in "family-based" emails or MMSes and warns users not to use them.
 * (with "family-based" communications, a single parent will receive 1 email for all of their kids, so {{contact.name}}
 * is ambiguous.
 *
 * @param communicationType  The type of thing we're sending, i.e. "email", "message"
 * @param findBody           Method to find the body of the text given the model, i.e. (model) => model.email.snippet.body
 * @returns                  A function that can be passed to the `warnings` prop on a `CommunicationWorkflow`
 */
export const FamilyContactTokenWarning = ({communicationType, body = ""}) => {
  const liquidTokens = liquidObjectsUsed(body);

  const badTokens = liquidTokens.filter(({object}) => object === 'contact');

  if (badTokens.some(x => x)) {
    return <div className={'alert alert-warning'}>
      <p>
        <FontAwesome icon={faExclamationTriangle} className={'communiction-workflow-warning-icon'} nbsp/>
        This {communicationType} contains tokens which will not display correctly in a family-based {communicationType}.
      </p>
      <p>
        Please consider removing the following {pluralize(badTokens.length, 'token')}:
      </p>
      <ul>
        {
          badTokens
            .map(({usage}) => <li>{usage}</li>)
            .map(ensureKeyed())
        }
      </ul>
    </div>;
  }

  return null;
};
